
import { useEffect, useRef } from 'react';
import { ethers } from 'ethers';
import { useWallet } from '../context/WalletContext';
import { useDolphin } from './useDolphin';

// This hook will auto-set the referrer for any user who does not have one, using URL/localStorage/default
export function useAutoRegisterReferrer({ defaultInviteCode = null } = {}) {
	const { account, isConnected } = useWallet();
	const { referralStats, setUserReferrer, txLoading } = useDolphin();
	const attemptedRef = useRef(false);

	useEffect(() => {
		if (!isConnected || !account || txLoading) return;
		if (referralStats?.hasReferrer) return;
		if (attemptedRef.current) return;

		// Try to get invite code from URL, then localStorage, then default
		let inviteCode = null;
		const urlParams = new URLSearchParams(window.location.search);
		const refParam = urlParams.get('ref');
		if (refParam) {
			try {
				inviteCode = ethers.utils.hexZeroPad(refParam, 32);
			} catch {
				inviteCode = refParam;
			}
		} else if (localStorage.getItem('inviteCode')) {
			try {
				inviteCode = ethers.utils.hexZeroPad(localStorage.getItem('inviteCode'), 32);
			} catch {
				inviteCode = localStorage.getItem('inviteCode');
			}
		} else if (defaultInviteCode) {
			inviteCode = defaultInviteCode;
		}

		if (inviteCode) {
			attemptedRef.current = true;
			setUserReferrer(inviteCode).catch(() => {});
		}
	}, [isConnected, account, referralStats, setUserReferrer, txLoading, defaultInviteCode]);
}
